<template>
  <div>
    <ul>
      <!-- <li class="textMedia">
        <a
          href="#"
          :class="{'isStop':isStop}"
          @click.prevent="saftAsk2"
        >
          赚吧
        </a>
      </li> -->
      <li class="textMedia" v-for="(item, index) in $store.state.user.userInfo.rolePermission" :key="index"
        @click.prevent="saftAsk(item.permissionId)" v-show="
          item.permissionId == '赚吧' || item.permissionId == '共享规则预约'
        ">
        <a href="#" :class="{ isStop: isStop }">
          {{ item.permissionId }}
        </a>
      </li>
      <li>
        <a href="#" @click.prevent="toAssist">远程协助</a>
      </li>
      <li>
        <a href="#" @click.prevent="toFeedBack">意见反馈</a>
      </li>
      <li class="pr">
        <a href="#" @click.prevent="connectTe" target="_blank">联系技术专家</a>
        <ewmCom ref="ewmCom" />
      </li>
      <li>
        <a :href="$PAGE_API.other.helpCenter" target="_blank">帮助中心</a>
      </li>
      <li>
        <a :href="$PAGE_API.other.downloadApp" target="_blank">软件下载</a>
      </li>
      <li style="line-height:0px;">
        <hover-down v-show="$route.query.isSelf != 2" class="header-user-down">
          <div slot="hoverBtn">
            <user-icon></user-icon>
          </div>
          <div slot="down" class="user-down" style="z-index: 999;">
            <router-link to="/home/VIPInfo" class="drop-row" style="height:60px;line-height:normal;padding:0;" tag="div"
              v-show="$store.state.user.userInfo.passportType != 3">
              <div class="info free" @click="
                nonactivatedFree('你有一次30天免费试用机会，快来体验下吧！')
              " v-show="
  $store.state.user.userInfo.judgeVip == 0 ||
  $store.state.user.userInfo.vipStatus == 0
">
                <div class="cla">免费版</div>
                <div>前去成为会员 ></div>
              </div>
              <div class="info free" v-show="
                $store.state.user.userInfo.judgeVip == 1 &&
                $store.state.user.userInfo.vipStatus > 0
              ">
                <div class="cla">免费版</div>
                <div>限时使用SVIP30天 ></div>
              </div>
              <div class="info vip" v-show="
                $store.state.user.userInfo.judgeVip == 2 &&
                $store.state.user.userInfo.vipStatus > 0
              ">
                <div class="cla">VIP</div>
                <div>
                  <span v-text="$store.state.user.userInfo.expireDate"></span>
                  >
                </div>
              </div>
              <div class="info svip" v-show="
                $store.state.user.userInfo.judgeVip == 3 &&
                $store.state.user.userInfo.vipStatus > 0
              ">
                <div class="cla">SVIP</div>
                <div>
                  <span v-text="$store.state.user.userInfo.expireDate"></span>
                  >
                </div>
              </div>
            </router-link>
            <router-link to="/home/OEMInfo" class="drop-row" tag="div" v-show="
              $store.state.user.userInfo.passportType != 3 &&
              $store.state.user.userInfo.vipStatus > 0
            ">
              <span></span>
              <span>
                <img src="@/assets/img/icon/u360.svg" alt="" />
                设置OEM信息
              </span>
            </router-link>
            <router-link to="/home/VIPInfo" class="drop-row" tag="div" v-show="
              $store.state.user.userInfo.passportType != 3 &&
              $store.state.user.userInfo.vipStatus == 0 &&
              $store.state.user.userInfo.judgeVip > 1
            ">
              <span></span>
              <span>
                <img src="@/assets/img/icon/u360.svg" alt="" />
                设置OEM信息
              </span>
            </router-link>
            <div class="drop-row" @click="
              nonactivatedFree(
                '此为会员特权功能，你有一次30天免费试用机会，快来体验下吧！'
              )
            " v-show="
  $store.state.user.userInfo.passportType != 3 &&
  $store.state.user.userInfo.judgeVip == 0 &&
  $store.state.user.userInfo.vipStatus == -1
">
              <span></span>
              <span>
                <img src="@/assets/img/icon/u360.svg" alt="" />
                设置OEM信息
              </span>
            </div>
            <div class="drop-row" @click="openFree" v-show="
              $store.state.user.userInfo.passportType != 3 &&
              $store.state.user.userInfo.judgeVip == 1 &&
              $store.state.user.userInfo.vipStatus == 0
            ">
              <span></span>
              <span>
                <img src="@/assets/img/icon/u360.svg" alt="" />
                设置OEM信息
              </span>
            </div>
            <router-link to="/home/userInfo" class="drop-row" tag="div">
              <span></span>
              <span>
                <img src="@/assets/img/icon/userInfo.png" alt="" />
                设置用户信息
              </span>
            </router-link>
            <div class="drop-row" @click="logout">
              <span></span>
              <span>
                <img src="@/assets/img/icon/logout.png" alt="" />
                退出登录
              </span>
            </div>
          </div>
        </hover-down>
      </li>
    </ul>
    <feed-back :showFeed="feed" @sendShow="getShow"></feed-back>
    <Modal v-model="modal1" title="共享规则库预约" @on-ok="ok" width="800px" ok-text="立即预约" @on-cancel="cancel">
      <h3 style="font-size:16px;">
        2020年11月中下旬，我将带着更好与沉稳，与志同道合的你再次相约，维护大师安全中心客户端与共享规则库即将限量开放，现预约正式开启！
      </h3>
      <p style="margin-top:10px;">
        1.
        <b>提供服务而非工具：</b>规则共享模式，用户间共享规则，登录维护大师Web端，规则拿来就能用，不再需要自己抓，自己试，让你有更多的时间陪伴家人。
      </p>
      <p style="margin-top:10px;">
        2.
        <b>全新“云终端”架构：</b>单exe客户端，进程少，体积小，无需设置服务器IP、不依赖维护大师服务端、无需注册网吧ID，开机启动即可使用，超级用户不工作，你需要的都有了！
      </p>
      <p style="margin-top:10px;">
        3.
        <b>全新的管理体验：</b>通过维护大师Web端即可对云终端进行管控，规则变动后，终端重启立即生效。功能、规则，想开想关，点下鼠标就能搞定。
      </p>
      <p style="margin-top:20px;">填写调研问卷，预约共享规则库资格！</p>
    </Modal>
  </div>
</template>
<script>
// 更多悬浮
// import CryptoJS from "crypto-js"; //加密js
import { Encrypt } from '@/utils/secret'
import HoverDown from '_c/dropdown/hoverDown'
// 头像部分
import ewmCom from '../../../components/modals/ewm.vue'
import UserIcon from './userIcon'
import { logout, freeTrial } from '@/requests/user'
import feedBack from '../modals/feedback'
import { mapActions } from 'vuex'
export default {
  name: 'sideMenu',
  components: {
    UserIcon,
    HoverDown,
    feedBack,
    ewmCom
  },
  data () {
    return {
      feed: false,
      modal1: false,
      isStop: false,
      id: '',
    }
  },
  mounted () {
    setTimeout(() => {
      this.isStop = true
    }, 1000 * 30)
  },
  methods: {
    connectTe () {
      this.$refs.ewmCom.visible = true
    },
    ok () {
      window.open('//wj.qq.com/s2/7451711/27dc', '_blank')
    },
    // saftAsk2() {
    //   // console.log(this.$Cookie.getCookie("txt"))
    // },
    cancel () { },
    saftAsk (id) {
      if (id == '共享规则预约')
      {
        this.modal1 = true
        this.isStop = true
      } else if (id == '赚吧')
      {
        //http://www.zhuanbar.com/autoLogin/
        let url =
          'http://zhuanbar.com/autoLogin' +
          `?account=${this.$Cookie.getCookie('username')}` +
          '&' +
          `txt=${this.Encrypt(this.$Cookie.getCookie('txt'))}`
        //console.log(url)
        window.open(url, '_blank')
      }
    },
    Encrypt,
    ...mapActions(['user/actionSetUserInfo']),
    toAssist () {
      window.$modal.toAssistModal.show()
    },
    toFeedBack () {
      this.feed = true
    },
    getShow (data) {
      this.feed = data
    },
    nonactivatedFree (msg) {
      window.$Message.show({
        title: '试用SVIP',
        type: 'error',
        msg: msg,
        cancleBtn: true,
        confirmTxt: '免费试用',
        confirmFn: async () => {
          let res = await freeTrial({
            passportName: this.$store.state.user.userInfo.passportName,
          })
          if (res.code == 200)
          {
            window.$Message.hide()
            window.$Message.show({
              title: '试用SVIP',
              type: 'success',
              msg: res.msg,
              confirmTxt: '关闭',
              confirmFn: () => {
                this['user/actionSetUserInfo']()
                window.$Message.hide()
              },
            })
          } else
          {
            setTimeout(() => {
              window.$Message.show({
                title: '试用SVIP',
                type: 'error',
                msg: res.msg,
                confirmFn: () => {
                  window.$Message.hide()
                },
              })
            }, 100)
          }
        },
      })
    },
    openFree () {
      window.$Message.show({
        title: '特权功能',
        type: 'error',
        msg: '开通会员后便可无限制的使用该功能，快来尝试下吧！',
        cancleBtn: true,
        confirmTxt: '开通会员',
        confirmFn: async () => {
          window.$Message.hide()
          this.$router.push({
            path: '/home/VIPInfo',
          })
        },
      })
    },
    logout,
  },
}
</script>

<style lang="scss" scoped>
@import '_style/cssfn/common.scss';

ul {
  @include clearfix();

  li {
    float: left;
    cursor: pointer;
    height: 60px;

    a {
      display: block;
      color: #fff;
      font-size: 14px;
      padding-left: 12px;
      padding-right: 12px;
      transition: all 0.3s;
    }

    &:hover {
      background: #0c1014;

      a {
        color: #00ccff;
      }
    }
  }
}

.info {
  width: 100%;
  height: 100%;

  div {
    margin-left: 13px;
    line-height: 20px;
    font-size: 12px;
  }

  .cla {
    padding-top: 10px;
    font-size: 14px;
  }
}

.info.free {
  background: url('../../../assets/img/icon/u358.png') no-repeat;
  background-size: 100%;
}

.info.vip {
  background: url('../../../assets/img/icon/u704.png') no-repeat;
}

.info.svip {
  background: url('../../../assets/img/icon/u718.png') no-repeat;
}
</style>
<style lang="scss">
.header-user-down {
  .dropdown {
    padding: 0 !important;
    // right: 50px !important;
    top: 55px !important;
    width: 200px !important;
    left: -58px !important;
  }

  .default-dropdown {
    width: 200px;
    background-color: rgba(37, 42, 47, 1);
    right: 20px;
    padding-left: 0;

    .drop-row {
      height: 40px;
      line-height: 40px;

      img {
        float: left;
        margin: 13px 5px 0 5px;
      }

      &:hover {
        background-color: rgba(25, 28, 31, 1);
      }
    }
  }
}

.textMedia {
  a {
    color: #ffd900 !important;
  }

  &:nth-child(1) a {
    color: #ff0037 !important;
  }
}

.textMedia a {
  font-weight: bolder !important;
  /* color: #e7e7e7;
  text-shadow: 1.5px 1.5px 0 #333, 0px 1.5px 0 #333, -1.5px -1.5px 0 #333,
    -1.5px -1.5px 0 #333, -1.5px 1.5px 0 #333, 1.5px -1.5px 0 #333,
    0.77782px 0.77782px 0 #aaaaaa, 1.55563px 1.55563px 0 #aaaaaa,
    2.33345px 2.33345px 0 #aaaaaa, 3.11127px 3.11127px 0 #aaaaaa,
    3.88909px 3.88909px 0 #aaaaaa, 4.6669px 4.6669px 0 #aaaaaa,
    5.44472px 5.44472px 0 #aaaaaa, 6.22254px 6.22254px 0 #aaaaaa,
    7.00036px 7.00036px 0 #aaaaaa, 7.77817px 7.77817px 0 #aaaaaa; */
  animation: bounce 1.5s cubic-bezier(0.05, 0, 0.2, 1) infinite alternate;

  &.isStop {
    animation: bounce 1.5s cubic-bezier(0.05, 0, 0.2, 1);
  }

  display: inline-block;
  transform: translate3d(0, 0, 0);
  margin-top: 1.2em;
  font-size: 16px !important;

  text-shadow: rgba(255, 255, 255, 0.4) 0 0 0.05em;
  font: normal 500 6rem 'Varela Round',
  sans-serif;

  &:nth-child(1) {
    animation-delay: 0s;
  }

  &:nth-child(2) {
    animation-delay: 0.0833333333s;
  }

  &:nth-child(3) {
    animation-delay: 0.1666666667s;
  }

  &:nth-child(4) {
    animation-delay: 0.25s;
  }

  &:nth-child(5) {
    animation-delay: 0.3333333333s;
  }

  &:nth-child(6) {
    animation-delay: 0.4166666667s;
  }
}

@keyframes bounce {
  0% {
    transform: translate3d(0, 0, 0);
    text-shadow: rgba(245, 245, 245, 0.459) 0 0 0.05em;
  }

  50% {
    transform: translate3d(1em, 0, 0);
    text-shadow: rgba(245, 245, 245, 0.726) 0 1em 0.5em;
  }

  100% {
    transform: translate3d(0, 0, 0);
    text-shadow: rgba(245, 245, 245, 0.726) 0 0em 0.05em;
  }
}
</style>
